import { Outlet, useNavigate } from "react-router-dom";

function Blog(){
  return(
    <>
      <Outlet></Outlet>
    </>
  )
}
export default Blog;